export default __webpack_public_path__ + "static/media/ConnectionIconGreen.f0765e79.svg";